import React from "react";
import { LandingSection } from "../Home/LandingSection";
import ContactForm from "./ContactForm";
import ContactSVG from "./contactImg.svg";
import "./style.scss";

const ContactUs = () => {
  return (
    <div className="contact-container">
      <LandingSection
        hideButton
        titleClass="unblold"
        image={ContactSVG}
        title="Say Hello!"
        description={`We value communication with our customers, even in challenging times. Please don't hesitate to reach out to us to schedule an appointment or share your requirements. We will get back to you at the earliest convenience.`}
      />
  <div className="contact-form-container">
    <span className="title">Get in touch with us!</span>
  <ContactForm/>
  </div>
    </div>
  );
};
export default ContactUs;
